export default "__VITE_ASSET__6Za2a86a__"